import React, { useEffect } from "react";
import Footer from "../components/atoms/footer";


const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="container mt-4">
        <h1 style={{ textAlign: "center" }}>Terms of Service Agreement</h1>
        <p>
          <strong>Last updated:</strong> May 29, 2026
        </p>

        <p>
          These Terms of Service constitute a legally binding agreement between
          you and Enlive Systems, Inc. (together with its affiliates, "Enlive", “the Company”,
          “we,” “our” or “us”) governing your use of our products, services,
          mobile application (the “App”), and website (the “Site” and
          collectively with the foregoing, the “Services”).
        </p>
        <p>
          BY CLICKING ON THE “GET STARTED" BUTTON, REGISTERING FOR AN
          ACCOUNT, DOWNLOADING THE APP OR ANY APP UPGRADES, USING THE APP ON
          YOUR MOBILE DEVICE, OR ACCESSING OR USING THE SERVICES, YOU ARE
          INDICATING THAT YOU HAVE READ, UNDERSTAND AND AGREE TO BE BOUND BY
          THESE TERMS OF SERVICE, WHETHER OR NOT YOU HAVE REGISTERED WITH THE
          SITE OR THE APP.
          </p>
          <p>
          THIS AGREEMENT CONSTITUTES THE ENTIRE AND ONLY AGREEMENT BETWEEN ENLIVE
          AND YOU, AND SUPERSEDES ALL PRIOR OR CONTEMPORANEOUS AGREEMENTS,
          REPRESENTATIONS, WARRANTIES AND UNDERSTANDINGS WITH RESPECT TO THE
          SERVICES AND/OR THE SUBJECT MATTER OF THIS AGREEMENT. THE LATEST
          AGREEMENT WILL BE POSTED ON AND AVAILABLE THROUGH ENLIVE’S PROVISION OF
          THE SERVICES. YOU MUST REVIEW THIS AGREEMENT IN ITS ENTIRETY PRIOR TO
          USING THE SERVICES. IF YOU DO NOT AGREE TO THESE TERMS OF SERVICE,
          THEN YOU HAVE NO RIGHT TO ACCESS OR USE THE SERVICES.
          </p>
          <p>
          These Terms of Service are effective as of the date you first click “Get
          Started” (or similar button or checkbox) or use or access the Services,
          whichever is earlier. If you accept or agree to these Terms of Service
          on behalf of your employer or another legal entity, you represent and
          warrant that (i) you have full legal authority to bind your employer
          or such entity to these Terms of Services; (ii) you have read and
          understand these Terms of Service; and (iii) you agree to these Terms
          of Service on behalf of the party that you represent and any permitted
          users of such party. In such an event, “you” and “your” will refer and
          apply to your employer or such other legal entity.
          </p>
          <p>
          Any personal data you submit to us or which we collect about you is
          governed by our Privacy Policy (“Privacy Policy”), available at {" "} 
          <a
                href="https://www.enlive.inc/privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "blue" }}
              >
                https://www.enlive.inc/privacypolicy.
              </a>
          {" "} You acknowledge that by using
          the Services, you have reviewed the Privacy Policy. The Privacy Policy
          is incorporated by reference into these Terms of Service and together
          form and are hereinafter referred to as this “Agreement.”
          </p>
        

        <h2>1. Our Services</h2>
        <p>
          We provide a software-based platform for users to interact with various 
          AI tools and receive personal feedback with their data.
        </p>

        <h2>2. Account, Password and Security</h2>
        <p>
          You must register with Enlive in order to create an account to use the
          Services (an “Account”). In setting up an Account, you will be
          requested to provide certain information, such as your name 
          and email address. You expressly agree to provide true, accurate, 
          current and complete
          information as prompted by the registration process and to maintain
          and promptly update the Account information to update as required in
          order to keep it accurate, current and complete. <br />
          <br />
          The person signing up for the Services will be the contracting party
          (“Account Owner”) for the purposes of these Terms of Service. Subject
          to the last paragraph of this section, you are the sole authorized
          user of your Account. You are solely and fully responsible for the
          following: (i) maintaining the confidentiality of any log-in,
          password, and Account number provided by you or given to you by Enlive
          for accessing the Services; (ii) all activities that occur under your
          password or Account; (iii) contacting the Company immediately should you
          suspect that any unauthorized party may be using your password,
          identity or Account, or that any other breach of security may have
          occurred. Enlive hereby expressly disclaims any all liability derived or
          arising from use of your Account.
          <br />
          <br />
          In the event that you are signing up for the Services on behalf of
          your employer, then your employer shall be the Account Owner. Only the
          Account Owner is entitled to all benefits accruing thereto. Accounts
          are not transferable to any other person or entity.
        </p>

        <h2>3. Content</h2>
        <p>
          The viewing, printing or downloading of any content, graphic, form or
          document from the Services grants you only a limited, nonexclusive
          license for use solely by you for your own personal use and not for
          republication, distribution, assignment, sublicense, sale, preparation
          of derivative works or other use. No part of any content, form or
          document may be reproduced in any form or incorporated into any
          information retrieval system, electronic or mechanical, other 
          than for your personal use (not for resale or redistribution).
          <br />
          <br />
          All content, organization, graphics, design, audio, animation, video,
          compilation, magnetic translation, digital conversion and other
          matters related to the Services are protected under applicable
          copyrights, trademarks and other proprietary (including but not
          limited to intellectual property) rights.
          <br />
          <br />
          “User Content” is defined as any content, information, and materials
          that may be textual, audio, or visual that you provide, submit,
          upload, publish, or make otherwise available to the Services. You are
          solely responsible for User Content. You agree that you are the only
          one responsible for the User Content you send, transmit, display, or
          upload while using the Services. You agree that you will obey all laws
          and regulations that apply to the User Content, including, but not
          limited to, any laws that require you to get permission from a third
          party to use the User Content and to give proper notices of
          third-party rights. You promise and guarantee that you have the legal
          right to provide access to the User Content and that doing so does not
          violate or infringe on the rights of any third party. Under no
          circumstances will Enlive be responsible for (a) User Content that is
          sent or viewed while using the Services, (b) errors or omissions in
          the User Content, or (c) any loss or damage of any kind caused by the
          authorized use of, access to, or denial of access to User Content.
          Further, you expressly acknowledge and agree that Enlive: is not involved
          in the creation or development of User Content; disclaims any
          responsibility for User Content; cannot be liable for claims arising
          out of or relating to User Content; and is not obligated to monitor,
          review, or remove User Content, but reserves the right to limit access
          to User Content on the Services at its sole discretion.
        </p>

        <h2>4. Representations and Warranties</h2>
        <p>
          You represent and warrant that: (i) you are 13 years of age or older,
          (ii) you have the right, authority and capacity to enter into this
          Agreement and to abide by the terms and conditions of this Agreement,
          and that you will so abide; (iii) you have read, understand, and agree
          to be bound by these Terms of Service and the Privacy Policy in order
          to access and use the Services, (iv) you will act responsibly in your 
          interactions with other users, and (v) when using
          or accessing the Services, you will act in accordance with any
          applicable local, state, or federal law or custom and in good faith.
          You agree not to engage in any of the following prohibited activities,
          among others: introducing malware; spamming, hacking, or bypassing our
          systems or protective measures; jailbreaking, adversarial prompting,
          or prompt injection; accessing or using our services or content in
          fraudulent or deceptive ways, such as: phishing, creating fake
          accounts or content, including fake reviews, misleading others into
          thinking that generative AI content was created by a human, providing
          services that appear to originate from you (or someone else) when they
          actually originate from us, providing services that appear to
          originate from us when they do not, using Services (including the
          content they provide) to violate anyone’s legal rights, such as
          intellectual property or privacy rights, reverse engineering our
          services or underlying technology, such as our machine learning
          models, to extract trade secrets or other proprietary information,
          except as allowed by applicable law, using automated means to access
          content from any of our services in violation of the machine-readable 
          instructions on our web pages (for example, robots.txt files that 
          disallow crawling, training, or other activities),
          using AI-generated content from our Services to develop machine
          learning models or related AI technology, hiding or misrepresenting
          who you are in order to violate these terms, providing services that
          encourage others to violate these terms; copying, distributing, or
          disclosing any part of the Services in any medium other than as
          allowed by the Services and these Terms of Service; illegally or
          irresponsibly using any third-party AI model(s) that may be available
          to you in connection with the Services; using any automated system
          (other than any functionalities of the Services), including without
          limitation “robots,” “spiders,” “offline readers,” etc., to access the
          Services; transmitting spam, chain letters, or other unsolicited email
          or attempting to phish, pharm, pretext, spider, crawl, or scrape;
          attempting to interfere with, compromise the system integrity or
          security or decipher any transmissions to or from the servers running
          the Services; violating any international, federal, provincial or
          state regulations, rules, laws, or local ordinances; conducting any
          unlawful purposes or soliciting others to perform or participate in
          any unlawful acts; uploading invalid data, viruses, worms, or other
          software agents through the Services; infringing upon or violate our
          intellectual property rights or the intellectual property rights of
          others; impersonating another person or otherwise misrepresenting your
          affiliation with a person or entity, conducting fraud, hiding or
          attempting to hide your identity; harassing, insulting, harming,
          abusing, defaming, abusing, harassing, stalking, threatening,
          intimidating or otherwise violating the legal rights (such as of
          privacy and publicity) of any other users or visitors of the Services
          or staff member of Enlive Systems, Inc.; interfering with or any activity that
          threatens the performance, security or proper functioning of the
          Services; uploading or transmitting viruses or any other type of
          malicious code; attempting to decipher, decompile, disassemble or
          reverse engineer any of the software or algorithms used to provide the
          Services; bypassing the security features or measures we may use to
          prevent or restrict access to the Services, including without
          limitation features that prevent or restrict use or copying of any
          content or enforce limitations on use of the Services or the content
          therein; attempting to access unauthorized Accounts or to collect or
          track the personal information of others; using the Services for any
          purpose or in any manner that infringes the rights of any third party;
          or encouraging or enabling any other individual to do any of the
          foregoing.
          <br />
          <br />
          You hereby warrant and represent that, other than as fully and
          promptly disclosed to Enlive as set forth below, you do not have any
          motivation, status, or interest which the Company may reasonably wish to know
          about in connection with the Services, including without limitation,
          if you are using or will or intend to use the Services for any
          unlawful purpose. You hereby warrant and represent that you will
          promptly disclose to Enlive in writing any such motivation, status or
          interest, whether existing prior to registration or as arises during
          your use of the Services.
        </p>

        <h2>5. Artificial Intelligence Services</h2>
        <p>
          Enlive does employ Artificial Intelligence (AI) or other similar
          technologies, which includes the processing of user data. We will
          take reasonable means to preserve the privacy and security of such
          data as more fully set forth by Enlive’s Privacy Policy, but the Company is not
          liable for any loss or harm resulting from the user's use of AI or
          similar technologies. By utilizing Enlive's Services, the user
          understands and accepts the risks involved with the use of AI or
          similar technologies and agrees to indemnify and hold Enlive harmless
          for any claims, damages, or losses resulting from such usage.
        </p>

        <h2>6. Termination and Suspension of Account</h2>
        <p>
          You may cancel and delete your Account at any time by either navigating
          to the My Profile page (see Privacy Policy for more detail) or by
          email notice to Enlive Systems, Inc. at ask.support@enlive.inc.
          After cancellation your profile will be purged and, you will no longer
          have access to your Account, your profile or any other information
          through the Services. The provisions of these Terms of Service which
          by their intent or meaning intended to survive such termination,
          including without limitation the provisions relating to disclaimer of
          warranties, limitations of liability, and indemnification, shall
          survive any termination of these Terms of Service and any termination
          of your use of or subscription to the Services and shall continue to
          apply indefinitely.
          <br />
          <br />
          At any time and for any reason, we have the right to deny access to
          the Services to anybody. If Enlive is investigating you or believes you
          have violated any of the terms of this Agreement, we may prevent you
          from accessing the Services or restrict how much of them you can use,
          and such notice of termination or limitation shall be effective
          immediately. You cannot register for and create a new Account in the
          name of a third party, a fake or borrowed name, or your own identity
          if Enlive terminates or restricts your ability to use the Services due
          to this section, even if you are acting on their behalf.
          <br />
          <br />
          Even after your right to use the Services is terminated or limited,
          this Agreement will remain enforceable against you. Enlive reserves the
          right to take appropriate legal action, including but not limited to
          pursuing arbitration in accordance with Section 14 of these Terms of
          Service.
          <br />
          <br />
          Enlive reserves the right to modify or discontinue, temporarily or
          permanently, all or any portion of the Services at its sole
          discretion. Enlive is not liable to you for any modification or
          discontinuance of all or any portion of the Services. Enlive has the
          right to restrict anyone from completing registration as a user if
          Enlive believes such a person may threaten the safety and integrity of
          the Services, or if, in the Company's discretion, such restriction is
          necessary to address any other reasonable business concern.
          <br />
          <br />
          Following the termination or cancellation of your Account (as defined
          below), we reserve the right to delete all your data in the normal
          course of operation. Your data cannot be recovered once your Account
          is terminated or canceled.
          <br />
          <br />
        </p>

        <h2>7. Links to Third-Party Websites</h2>
        <p>
          The Services may contain links to other web sites run or administered
          by third parties. Enlive is not responsible for the content, accuracy or
          opinions express in such other web sites, and such web sites are not
          investigated, monitored or checked for accuracy or completeness by
          Enlive. Inclusion of any linked Web Site on any Services does not imply
          approval or endorsement of the linked web site or any related content
          or information by the Company. If you decide to access any third-party web
          site(s), you do so at your own risk.
          <br />
          <br />
          The terms and conditions of use and privacy policies for any website
          controlled, owned, or run by a third party dictate the use of same by
          you. You use these websites run by other people at your own risk. Enlive
          is not responsible for anything that happens because you use or look
          at third-party websites or other content linked from the Services. You
          agree to not hold Enlive responsible for any claims, causes of action or
          other circumstances arising from your access or use of any third-party
          web site(s).
        </p>

        <h2>8. Intellectual Property Rights</h2>
        <p>
          Enlive Systems, Inc. is the sole and exclusive owner of any and all text, graphics,
          data, formatting, graphs, designs, HTML, look and feel, photographs,
          music, sounds, images, software, videos, Company trademarks, Company logos, typefaces
          and other content (collectively “Proprietary Material”) that users see
          or read through the Services. You hereby grant to Enlive a license to
          use User Content as set forth herein. Proprietary Material is
          protected in all forms, media and technologies now known or
          hereinafter developed. Enlive owns all Proprietary Material, as well as
          the coordination, selection, arrangement and enhancement of such
          Proprietary Materials as a Collective Work under the United States
          Copyright Act, as amended. The Proprietary Material is protected by
          the domestic and international laws governing copyright, patents, and
          other proprietary rights. You may not copy, download, use, redesign,
          reconfigure, or retransmit anything from the Services without Enlive’s
          express prior written consent.
          <br />
          <br />
          Any use of such Proprietary Material, other than as permitted therein,
          is expressly prohibited without the prior permission of Enlive.
          <br />
          <br />
          The service marks and trademarks of Enlive Systems, Inc., including without limitation
          Company logos, are owned by the Company. Any other
          trademarks, service marks, logos and/or trade names appearing via the
          Services are the property of their respective owners. You may not copy
          or use any of these marks, logos or trade names without the express
          prior written consent of the owner.
          <br />
          <br />
          <ul>
            <li>
              Google Drive is the trademark of Google LLC.
            </li>
            <li>
              Gmail is the trademark of Google LLC.
            </li>
            <li>
              OneDrive is the trademark of Microsoft LLC.
            </li>
            <li>
              Outlook is the trademark of Microsoft LLC.
            </li>
          </ul>
        
          Additionally, you may choose to or we may invite you to submit
          comments, ideas, or feedback about the Services, including without
          limitation about how to improve our services or our products
          (“Feedback”). By submitting any Feedback, you agree that your
          disclosure is gratuitous, unsolicited, and without restriction and
          will not place Enlive under any fiduciary or other obligation, and that
          we are free to use the Feedback without any additional compensation to
          you, and/or to disclose the Feedback on a non-confidential basis or
          otherwise to anyone. You further acknowledge that, by acceptance of
          your submission, the Company does not waive any rights to use similar or
          related Feedback previously known to Enlive, developed by its employees,
          or obtained from sources other than you. You acknowledge that all
          email and other correspondence that you submit to us shall become our
          sole and exclusive property.
          <br />
          <br />
          In addition, Enlive retains all rights to aggregated and anonymous data
          derived from your use of the Service, without reference to personal
          data/files, with the understanding that such data will not be
          identifiable as belonging to or emanating from you nor will such data
          contain information that directly or indirectly identifies you or any
          other person (natural or otherwise). <br />
          <br />
          Subject to the terms and conditions hereof, you are hereby granted a
          limited, nonexclusive, nontransferable, freely revocable, right to
          access and use the Services. We may terminate this right at any time
          for any reason or no reason. The Services and all materials therein or
          transferred thereby, including, without limitation, software, images,
          text, graphics, illustrations, logos, patents, trademarks, service
          marks, reports generated by the Services, and copyrights (the “Company
          Content”), and all Intellectual Property Rights (as defined below)
          related thereto, are the exclusive property of Enlive or, as applicable,
          its licensors. Except as explicitly provided herein, nothing in this
          Agreement shall be deemed to create a license or other right in or
          under any such Intellectual Property Rights, and you agree not to
          sell, license, rent, modify, publicly distribute, publicly transmit,
          publicly display, publicly perform, publish, adapt, edit or create
          derivative works from any materials or content accessible on the
          Services. Use of Enlive Content or materials on the Services for any
          purpose not expressly permitted by this Agreement is strictly
          prohibited. For the purposes of this Agreement, “Intellectual Property
          Rights” means all patent rights, copyright rights, mask work rights,
          moral rights, rights of publicity, trademark, trade dress and service
          mark rights, goodwill, trade secret rights and other intellectual
          property rights as may now exist or hereafter come into existence, and
          all applications therefore and registrations, renewals and extensions
          thereof, under the laws of any state, country, territory or other
          jurisdiction.
          <br />
          <br />
          Your use of the Services and the related licenses granted hereunder
          are also conditioned upon your strict adherence to the letter and
          spirit of the various applicable guidelines and any end user licenses
          associated with your use of the App. Enlive may modify such guidelines
          in its sole discretion at any time. Enlive reserves the right to
          terminate your Account and access to the Services if it determines
          that you have violated any such applicable guidelines.
          <br />
        </p>

        <h2>9. Copyright Complaints</h2>
        <p>
          All content, organization, graphics, design, audio, animation, video,
          compilation, magnetic translation, digital conversion and other
          matters related to the Services are protected under applicable
          copyrights, trademarks and other proprietary (including but not
          limited to intellectual property) rights. The copying, redistribution,
          use or publication by you of any such matters or any part of the
          Services is strictly prohibited. You do not acquire ownership rights
          to any content, document or other materials viewed through the
          Services. The posting of information or materials on any Company Site or
          App does not constitute a waiver of any right in such information and
          materials.{" "}
        </p>

        <h2>10. Confidential Information</h2>
        <p>
          You acknowledge that Confidential Information (as defined below) is a
          valuable, special and unique asset of Enlive Systems, Inc. and agree that you will not
          disclose, transfer, use (or seek to induce others to disclose,
          transfer or use) any Confidential Information for any purpose other
          than using the Services in accordance with these Terms of Service. If
          relevant, you may disclose the Confidential Information to your
          authorized employees and agents provided that they are also bound to
          maintain the confidentiality of Confidential Information. You shall
          promptly notify Enlive in writing of any circumstances that may
          constitute unauthorized disclosure, transfer, or use of Confidential
          Information. You shall use best efforts to protect Confidential
          Information from unauthorized disclosure, transfer or use. You shall
          return all originals and any copies of any and all materials
          containing Confidential Information to the Company upon termination of this
          Agreement for any reason whatsoever.
          <br />
          <br />
          The term “Confidential Information” shall mean any and all of Enlive’s
          trade secrets, confidential and proprietary information, and all other
          information and data of Enlive that is not generally known to the public
          or other third parties who could derive value, economic or otherwise,
          from its use or disclosure. Confidential Information shall be deemed
          to include technical data, know-how, research, product plans,
          products, services, customers, markets, software, developments,
          inventions, processes, formulas, technology, designs, drawings,
          engineering, hardware configuration information, marketing, finances,
          strategic and other proprietary and confidential information relating
          to Enlive or Enlive’s business, operations or properties, including
          information about Enlive’s staff, users or partners, or other business
          information disclosed directly or indirectly in writing, orally or by
          drawings or observation.
        </p>

        <h2>11. Disclaimer of Warranties</h2>
        <p>
          THE INFORMATION FROM OR THROUGH ENLIVE ARE PROVIDED “AS-IS,” “AS
          AVAILABLE,” AND ALL WARRANTIES, EXPRESS OR IMPLIED, ARE DISCLAIMED
          (INCLUDING BUT NOT LIMITED TO THE DISCLAIMER OF ANY IMPLIED WARRANTIES
          OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE). THE
          INFORMATION AND SERVICES MAY CONTAIN BUGS, ERRORS, PROBLEMS OR OTHER
          LIMITATIONS. ENLIVE SYSTEMS, INC., TOGETHER WITH ITS AFFILIATES
          AND/OR THEIR RESPECTIVE SUCCESSORS AND ASSIGNS, OFFICERS, DIRECTORS,
          EMPLOYEES, AGENTS, LICENSORS, REPRESENTATIVES, ADVERTISERS, BUSINESS
          AND PROMOTIONAL PARTNERS, OPERATIONAL SERVICE PROVIDERS, SUPPLIERS,
          RESELLERS AND CONTRACTORS (COLLECTIVELY “AFFILIATED PARTIES”), HAVE NO
          LIABILITY WHATSOEVER FOR YOUR USE OF ANY INFORMATION OR SERVICE. IN
          PARTICULAR, BUT NOT AS A LIMITATION THEREOF, ENLIVE AND ITS AFFILIATED
          PARTIES ARE NOT LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL OR
          CONSEQUENTIAL DAMAGES (INCLUDING DAMAGES FOR LOSS OF BUSINESS, LOSS OF
          PROFITS, LITIGATION, OR THE LIKE), WHETHER BASED ON BREACH OF
          CONTRACT, BREACH OF WARRANTY, TORT (INCLUDING NEGLIGENCE), PRODUCT
          LIABILITY OR OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
          DAMAGES. THE NEGATION OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL
          ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN US AND YOU. THE SERVICES
          AND THE INFORMATION WOULD NOT BE PROVIDED WITHOUT SUCH LIMITATIONS. NO
          ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM
          US THROUGH THE SERVICES SHALL CREATE ANY WARRANTY, REPRESENTATION OR
          GUARANTEE NOT EXPRESSLY STATED IN THIS AGREEMENT.
          <br />
          <br />
          ALL RESPONSIBILITY OR LIABILITY FOR ANY DAMAGES CAUSED BY VIRUSES IS
          EXPRESSLY DISCLAIMED BY ENLIVE AND ENLIVE WILL NOT BE LIABLE TO YOU FOR
          ANY INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND THAT MAY
          RESULT FROM USE OF OR INABILITY TO USE ANY COMPANY SITE OR APP. ENLIVE’S
          MAXIMUM LIABILITY TO YOU UNDER ALL CIRCUMSTANCES WILL BE EQUAL TO THE
          PURCHASE PRICE YOU PAY FOR ANY GOODS, SERVICES OR INFORMATION FROM
          THE COMPANY.
        </p>

        <h2>12. Indemnification</h2>
        <p>
          You hereby agree to indemnify, defend, and hold harmless Enlive and its
          officers, directors, employees, agents, attorneys, insurers,
          successors and assigns (the “Indemnified Parties”) from and against
          any and all Liabilities incurred in connection with (i) your use or
          inability to use the Services, or
          (ii) your breach or violation of this Agreement; (iii) your violation
          of any law, or the rights of any user or third party and (iv) any
          content submitted by you or using your Account to the Services,
          including, but not limited to the extent such content may infringe on
          the intellectual rights of a third party or otherwise be illegal or
          unlawful. You also agree to indemnify the Indemnified Parties for any
          Liabilities resulting from your use of software robots, spiders,
          crawlers, or similar data gathering and extraction tools, or any other
          action you take that imposes an unreasonable burden or loan on our
          infrastructure. Enlive reserves the right, in its own sole discretion,
          to assume the exclusive defense and control at its own expense of any
          matter otherwise subject to your indemnification. You will not, in any
          event, settle any claim or matter without the prior written consent of
          the Company.
        </p>

        <h2>13. Dispute Resolution – Arbitration & Class Action Waiver</h2>
        <p>
          <strong>
            PLEASE READ THIS SECTION CAREFULLY — IT AFFECTS YOUR LEGAL RIGHTS
            AND GOVERNS HOW YOU AND ENLIVE CAN BRING CLAIMS AGAINST EACH OTHER.
            THIS SECTION WILL, WITH LIMITED EXCEPTION, REQUIRE YOU AND THE COMPANY TO
            SUBMIT CLAIMS AGAINST EACH OTHER TO BINDING AND FINAL ARBITRATION ON
            AN INDIVIDUAL BASIS.
          </strong>{" "}
          <br />
          <br />
          Notice of Dispute. In the event of a Claim (as defined below), you or
          Enlive must give the other a Notice of Dispute, which is a written
          statement that sets forth the name, address, and contact information
          of the party giving it, the facts giving rise to the Claim, and the
          relief requested. You must send any Notice of Dispute by certified or
          registered U.S. Mail to Enlive Systems, Inc. at 8 the Green # 19675, Dover, DE 19901. 
          Enlive will send any Notice of Dispute to you by U.S. Mail to your address if
          we have it, or otherwise to your email address. You and Enlive must
          attempt to resolve any dispute in good faith through informal
          negotiation within sixty (60) days from the date the Notice of Dispute
          is received. After sixty (60) days, you or Enlive shall have the right,
          but not the obligation, to commence arbitration in accordance with
          this Section 14 of this Agreement.
          <br />
          <br />
          Agreement to Arbitrate Disputes. In the event that the parties are
          unable to resolve a Claim described in a Notice of Dispute through
          informal negotiation, such dispute must be resolved through binding
          arbitration before the American Arbitration Association (“AAA”). This
          means that neither you nor the Company will have the right to litigate that
          Claim in court or have a jury trial on that Claim. Other rights that
          you would have in court also may not be available or may be limited in
          arbitration, including your right to appeal and your ability to
          participate in a class action. Nothing in this provision precludes you
          from filing and pursuing your individual Claim in a small claims court
          of competent jurisdiction in your state or municipality, so long as
          that Claim is pending only in that court.
          <br />
          <br />
          Class Action Waiver and Other Restrictions. Arbitration shall proceed
          solely on an individual basis without the right for any Claim(s) to be
          arbitrated on a class action basis or on bases involving claims
          brought in a purported representative capacity on behalf of others.
          The arbitrator’s authority to resolve and make written awards is
          limited to Claims between you and Enlive alone. Claims may not be joined
          or consolidated unless agreed to in writing by all parties. No
          arbitration award or decision will have any preclusive effect as to
          issues or claims in any dispute with anyone who is not a named party
          to the arbitration. <br />
          <br />
          Arbitration Procedures. This Arbitration Provision is made pursuant to
          a transaction involving interstate commerce, and shall be governed by
          the Federal Arbitration Act, 9 U.S.C. Sections 1-16, as it may be
          amended (“FAA”), and the applicable Code. The arbitrator shall apply
          applicable substantive law consistent with the FAA and applicable
          statutes of limitations and shall honor claims of privilege recognized
          at law. Subject to the right of appeal under the FAA, the arbitrator’s
          written decision will be final and binding unless you or we take an
          appeal from the award by making a dated, written request to the
          arbitration organization within 30 days from the date of entry of the
          written arbitral award. A three-arbitrator panel administered by the
          AAA shall consider anew any aspect of the award objected to by the
          appellant, conduct an arbitration pursuant to its Code and issue its
          decision within 120 days of the date of the appellant’s written
          notice. The panel’s majority vote decision shall be final and binding.
          <br />
          <br />
          Location of Arbitration/Payment of Fees. The arbitration shall take
          place in Dover, Delaware. Irrespective of who prevails in
          arbitration, you will only be responsible for paying your share, if
          any, of the arbitration fees required by the applicable Code. <br />
        </p>

        <h2>14. Governing Law</h2>
        <p>
          Except as provided in Section 14 or expressly provided in writing
          otherwise, this Agreement and your use of the Services will be
          governed by, and will be construed under, the laws of the State of
          Delaware, without regard to choice of law principles. This choice of
          law provision is only intended to specify the use of Delaware law to
          interpret this Agreement.
        </p>

        <h2>15. No Agency; No Employment</h2>
        <p>
          No agency, partnership, joint venture, employer-employee or
          franchiser-franchisee relationship is intended or created by this
          Agreement.
        </p>

        <h2>16. General Provisions</h2>
        <p>
          Entire Agreement. This Agreement is the entire agreement between you
          and Enlive with respect to its subject matter, and supersedes all prior
          and contemporaneous proposals, statements and agreements. No statement
          or representation (verbal or otherwise) has been made by any party to
          this Agreement, in order to induce a party to execute this Agreement
          or any document or instrument to be executed pursuant hereto, which is
          not contained herein or in a written instrument to be executed and
          delivered pursuant to this Agreement. <br />
          <br />
          Assignment. Enlive Systems, Inc. shall have the right, but not the obligation, to
          assign this Agreement or any portion hereof to any Affiliated Party,
          successor in interest, or other person without your prior written
          consent. This Agreement is intended solely for the benefit of the
          parties and their respective successors and assigns. Nothing in this
          Agreement shall be construed to create any duty to, or standard of
          care with reference to, or liability of, any person not a party to
          this Agreement. Nothing in this Agreement shall be deemed to
          constitute any fiduciary or special relationship or duty between the
          parties.
          <br />
          <br />
          Waiver. No failure to exercise and no delay on the part of Enlive in
          exercising any power or right hereunder constitutes a waiver thereof,
          nor shall any single or partial exercise of any such right or power,
          or any abandonment or, discontinuance of steps to enforce such a right
          or power, preclude any other or future exercise of that right, power,
          or privilege or the exercise of any other right or power. <br />
          <br />
          Singular and Plural. Words used herein in the singular, where the
          context so permits, shall be deemed to include the plural and vice
          versa. The definitions of words in the singular herein shall apply to
          such words when used in the plural and vice versa, unless the context
          shall otherwise require.
          <br />
          <br />
          Titles of Articles, Sections and Subsections. All titles or headings
          to articles, sections, subsections or other divisions of this
          Agreement are only for the convenience of the parties and shall not be
          construed to have any effect or meaning with respect to the other
          content of such articles, sections, subsections or other divisions,
          such other content being controlling as to the agreement between the
          parties hereto.
          <br />
          <br />
          Cumulative Rights. The rights and remedies of Enlive under this
          Agreement shall be cumulative and not exclusive; the exercise or
          partial exercise of any such right or remedy shall not preclude the
          exercise of any other right or remedy provided in this Agreement or
          otherwise by law.
          <br />
          <br />
          Time for Action. Subject to Section 14 of this Agreement, any claim or
          cause of action by you with respect to any Company Site (and/or any
          information, products or services related thereto) must be instituted
          within one (1) year after the cause of action arose or be forever
          waived and barred. <br />
          <br />
          Severability. If any provision of this Agreement is determined to be
          invalid, illegal, or otherwise unenforceable (including, without
          limitation, Section 14 hereof), such provision shall be enforced as
          nearly as possible in accordance with the stated intention of the
          parties, while the remainder of this Agreement shall remain in full
          force and effect and bind the parties according to its terms. To the
          extent any provision cannot be enforced in accordance with the stated
          intentions of the parties, such provision shall be deemed not to be a
          part of this Agreement.
          <br />
          <br />
          Conflict. To the extent that anything in or associated with any Company
          Site is in conflict or inconsistent with this Agreement, this
          Agreement shall take precedence.
          <br />
        </p>

        <h2>17. Changes to this Agreement and the Services </h2>
        <p>
          Enlive reserves the right, at its sole and absolute discretion, to
          change, modify, add to, supplement, suspend, discontinue, or delete
          any of the terms and conditions of this Agreement (including these
          Terms of Service and Privacy Policy) and review, improve, modify or
          discontinue, temporarily or permanently, the Services or any content
          or information through the Services at any time, effective with or
          without prior notice and without any liability to Enlive. If any future
          changes to this Agreement are unacceptable to you or cause you to no
          longer be in compliance with this Agreement, you must terminate, and
          immediately stop using, the Services. Your continued use of the
          service after any and all modifications represents your acceptance of
          the agreement. In addition, Enlive Systems, Inc. may place restrictions on your use of
          specific features or limit your access to all or a portion of the
          services.
        </p>

        <h2>18. No Rights of Third Parties</h2>
        <p>
          None of the terms of this Agreement are enforceable by any persons who
          are not a party to this Agreement.
        </p>

        <h2>19. Notices and Consent to Receive Notices Electronically</h2>
        <p>
          You consent to receive any agreements, notices, disclosures and other
          communications (collectively, “Notices”) to which this Agreement
          refers electronically including without limitation by email or by
          posting Notices on this Site. You agree that all Notices that we
          provide to you electronically satisfy any legal requirement that such
          communications be in writing. Unless otherwise specified in this
          Agreement, all notices under this Agreement will be in writing and
          will be deemed to have been duly given when received, if personally
          delivered or sent by certified or registered mail, return receipt
          requested; when receipt is electronically confirmed, if transmitted by
          facsimile or email; or the day after it is sent, if sent for next day
          delivery by a recognized overnight delivery service.
        </p>

        <h2>20. Contacting Us</h2>
        <p>
          If you have any questions about these Terms of Service or about the
          Services, please contact us by email at ask.support@enlive.inc or by
          mail to 8 The Green # 19675, Dover, DE 19901.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;
